/**
 * Dependencies.
 */
import AddressModel from '@/api/address/address.model';

/**
 * Format address in a single line.
 */
const formatAddressSingleLine = ({
  address = null,
  showAdditionalInformation = false
}: {
  address: AddressModel;
  showAdditionalInformation?: boolean;
}) => {
  const {
    additionalInformation = null,
    city = null,
    countryName = null,
    doorNumber = null,
    street = null,
    zipCode = null
  } = address || {};

  let addressString = '';

  const streetPart = [street, doorNumber].filter(Boolean).join(' ');
  const cityPart = [zipCode, city].filter(Boolean).join(' ');

  addressString = [streetPart, cityPart, countryName]
    .filter(Boolean)
    .join(', ');

  if (showAdditionalInformation && !!additionalInformation) {
    addressString += ` (${additionalInformation})`;
  }

  return addressString;
};

/**
 * Export address utilities.
 */
export { formatAddressSingleLine };
